import React from 'react'

import isTouch from 'is-touch'


import './Intro.scss'

const Intro = ({isOpen, onClick, data, matchQuery, ...rest}) => {


    return (
        <>
        <section className={ [`intro`, `intro--${ !isOpen ? `is-closed` : `not-closed` }`].join( ` ` )} onClick={ onClick } >
        
            <div className={ `intro-stage`} >
                <h1 className={ `strong title` }>
                    <span>Unfolding Pavilion </span>
                    <span>Rituals of Solitude</span>
                </h1>
            
                <div className={`experience`}>
                        {
                            !isTouch
                                ? <p className={`experience-text strong _text`}>{data.pages.intro.message}</p>
                                : <p className={`experience-text strong _text`}>{data.pages.intro.mobile}</p>
                        }
                    
                 </div>

            </div>
            
        </section>
        </>
    )
}

export default Intro;